module.exports = __webpack_public_path__ + "img/brands-harrys-bg-1.png?a62e00fb18db4cde77777e5025efab39";